import {
  type FetchQueryOptions,
  type QueryClient,
} from '@tanstack/react-query';
import { sanityClient } from '../consts/client.const';
import type { RouteProps } from 'react-router';
import type { Vehicle } from '../types/vehicle.type';

export const vehicleQueryOptions = (
  vehicleId: string,
): FetchQueryOptions<Vehicle> => ({
  queryKey: ['VEHICLES'],
  queryFn: () => {
    const query = `
        *[_type == "vehicle" && slug.current == $slug][0]{
          "description": description[$lang],
          specification[]{ "label": label[$lang], "value": value[$lang], },
          features{ "description": description[$lang], items[]{ _key, "content": pl } },
          prices[]{ _key, "period": period[$lang], value },
          "images": gallery.images[]{ _key, alt, "url": asset->url },
          "slug": slug.current,
          name,
          seo{
          "description": description[$lang],
          "title": title[$lang],
          seo{"title": title[$lang], "description": description[$lang], "keywords": keywords[][$lang]},
          }
        }
      `;
    const params = { lang: 'pl', slug: vehicleId };

    return sanityClient.fetch<Vehicle>(query.replace(/\s/g, ''), params);
  },
});

export const vehicleLoader =
  (queryClient: QueryClient): RouteProps['loader'] =>
  async ({ params }) => {
    const queryOptions = vehicleQueryOptions(params.vehicleId!);

    return (
      queryClient.getQueryData(queryOptions.queryKey) ??
      (await queryClient.fetchQuery(queryOptions))
    );
  };
